module.exports = __webpack_public_path__ + "99ed12be094066a1db8160ff7d3e7e83.svg";